// LazyCardLoader.jsx
import { useEffect, useState, useRef, useCallback } from 'react';

const CHUNK_SIZE = 15;

const LazyCardLoader = ({ data, CardComponent, cardProps = {} }) => {
    const [visibleData, setVisibleData] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [hasScrolled, setHasScrolled] = useState(false);
    const loaderRef = useRef();

    const loadMore = useCallback(() => {
        setVisibleData(prev => {
            const nextChunk = data?.slice(prev.length, prev.length + CHUNK_SIZE);
            const updated = [...prev, ...nextChunk];
            setHasMore(updated.length < data.length);
            return updated;
        });
    }, [data]);

    useEffect(() => {
        const firstChunk = data?.slice(0, CHUNK_SIZE);
        setVisibleData(firstChunk);
        setHasMore(firstChunk?.length < data?.length);
        setHasScrolled(false);
    }, [data]);

    useEffect(() => {
        if (!hasMore || !loaderRef.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setHasScrolled(true);
                loadMore();
            }
        }, { rootMargin: '200px' });

        observer.observe(loaderRef.current);
        return () => observer.disconnect();
    }, [hasMore, loadMore]);

    return (
        <div>
            {visibleData.map((item, index) => (
                <CardComponent key={index} item={item} {...cardProps} i={index} />
            ))}

            {hasMore && <div ref={loaderRef} style={{ height: '1px' }} />}

            {hasMore && hasScrolled && (
                <div className="text-center py-3 text-muted">Loading more flights...</div>
            )}
        </div>
    );
};

export default LazyCardLoader;
